import { Button } from '@up2stay/up2promo-ui';
import { useDictionary } from '@up2promo-setup-frontend/ui/providers/dictionary.provider';
import { ArrowLeft } from 'lucide-react';

interface SetupHeaderProps {
  currentStep: number;
  maxSteps: number;
  onBack?: () => void;
}

export function SetupHeader({
  currentStep,
  maxSteps,
  onBack,
}: SetupHeaderProps) {
  const translations = useDictionary();
  const showBackButton =
    currentStep > 0 && currentStep < maxSteps - 1 && onBack;

  return (
    <div className="pointer-events-none fixed inset-x-0 top-0 z-50 flex items-center justify-between px-4 pb-2 pt-[max(1.25rem,env(safe-area-inset-top,0px))]">
      {/* White asset → ink in light, white in dark (system theme) */}
      <img
        src="/assets/images/brand/logo-white.svg"
        alt="up2promo"
        className="pointer-events-auto size-12 brightness-0 dark:brightness-100"
        width={48}
        height={48}
      />

      {showBackButton ? (
        <Button
          variant="ghost"
          size="md"
          onClick={onBack}
          aria-label={translations.general.back}
          className="pointer-events-auto min-h-11"
        >
          <ArrowLeft className="mr-2 h-5 w-5" />
          {translations.general.back}
        </Button>
      ) : (
        <span className="size-11" aria-hidden />
      )}
    </div>
  );
}
